module.exports = __webpack_public_path__ + "img/spain-cardiovascular-diseases-male.efa6269d.png";